import { Activity, Briefcase, CreditCard, Home, Palette, PanelLeftClose, PanelLeftOpen } from "lucide-react";
import React from "react";
import { NavLink } from "react-router-dom";

import { DASHBOARD_TABS } from "./constants";
import { getCompanyDashboardPath } from "./paths";

const ICONS = {
	home: Home,
	jobs: Briefcase,
	branding: Palette,
	activity: Activity,
	billing: CreditCard,
};

export function DashboardSidebar({ user, isCollapsed, onToggleCollapse }) {
	const initials = user.name
		.split(" ")
		.map((part) => part[0])
		.join("")
		.toUpperCase()
		.slice(0, 2);

	return (
		<aside
			className={`fixed left-0 top-0 z-20 flex h-screen flex-col bg-background transition-all duration-200 ${isCollapsed ? "w-[72px]" : "w-64"}`}
		>
			<div className={`${isCollapsed ? "px-3" : "px-4"} py-4`}>
				<div className="flex items-center justify-between">
					<NavLink to="/" className="flex items-center">
						<img src="/images/logo.png" alt="Dproz" className="h-12 w-12 object-contain" />
					</NavLink>
					<button
						type="button"
						onClick={onToggleCollapse}
						className="rounded-lg p-2 text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground"
					>
						{isCollapsed ? <PanelLeftOpen className="h-4 w-4" /> : <PanelLeftClose className="h-4 w-4" />}
					</button>
				</div>
			</div>

			<nav className={`flex-1 space-y-1 ${isCollapsed ? "px-2" : "px-3"}`}>
				{DASHBOARD_TABS.map((item) => {
					const Icon = ICONS[item.id];
					return (
						<NavLink
							key={item.id}
							to={getCompanyDashboardPath(item.id)}
							className={({ isActive }) =>
								`flex items-center rounded-xl px-3 py-2.5 text-sm font-medium transition-colors ${
									isCollapsed ? "justify-center" : "gap-3"
								} ${
									isActive
										? "bg-blue-50 text-primary-700"
										: "text-muted-foreground hover:bg-secondary hover:text-foreground"
								}`
							}
						>
							<Icon className="h-4 w-4" />
							{!isCollapsed ? <span>{item.label}</span> : null}
						</NavLink>
					);
				})}
			</nav>

			<div className={`${isCollapsed ? "px-2" : "px-3"} border-t border-border py-4`}>
				<div
					className={`rounded-xl p-2 ${isCollapsed ? "flex justify-center" : "flex items-center gap-3 hover:bg-secondary/60"}`}
				>
					{user.avatar ? (
						<img src={user.avatar} alt={user.name} className="h-10 w-10 rounded-full object-cover" />
					) : (
						<div className="company-dashboard-gradient flex h-10 w-10 items-center justify-center rounded-full text-sm font-semibold text-white">
							{initials}
						</div>
					)}
					{!isCollapsed ? (
						<div className="min-w-0">
							<p className="truncate text-sm font-semibold text-foreground">{user.name}</p>
							<p className="truncate text-xs text-muted-foreground">{user.email}</p>
						</div>
					) : null}
				</div>
			</div>
		</aside>
	);
}
